import type { PhotoPickerDialogProps } from './components/PhotoPickerDialog';
import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, createLazyComponent, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/*webpackChunkName: "PhotoPickerDialog"*/ './lazyIndex'),
    { name: 'PhotoPickerDialog' }
);

export const lazyMountAndShowPhotoPickerDialog: LazyAction<
    typeof lazyIndex.mountAndShowPhotoPickerDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.mountAndShowPhotoPickerDialog);

export const lazyInitializeLokiConfiguration: LazyAction<
    typeof lazyIndex.initializeLokiConfiguration,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeLokiConfiguration);

export const LazyPhotoPickerDialog: LazyComponent<PhotoPickerDialogProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.PhotoPickerDialog);

export { canUpdatePhoto } from './utils/capabilities';
